import { Type } from '@sinclair/typebox';
import { SupportedNetworkSchema } from '../supported-network.js';
export const PoolChartPointSchema = Type.Object({
    value: Type.String(),
    timestamp: Type.String(),
});
export const PoolChartsSchema = Type.Object({
    holdersCountChart: Type.Array(PoolChartPointSchema),
    top10HoldingChart: Type.Array(PoolChartPointSchema),
    insidersHoldingChart: Type.Array(PoolChartPointSchema),
    snipersHoldingChart: Type.Array(PoolChartPointSchema),
    bundlersHoldingChart: Type.Array(PoolChartPointSchema),
});
export const InitTxCreatorStatsSchema = Type.Object({
    balanceInToken: Type.Optional(Type.String()),
    buyVolumeInUsd: Type.Optional(Type.String()),
    sellVolumeInUsd: Type.Optional(Type.String()),
    buys: Type.Optional(Type.Number()),
    sells: Type.Optional(Type.Number()),
    lastTx: Type.Optional(Type.Object({
        at: Type.String(),
        amountInToken: Type.String(),
        amountInUsd: Type.String(),
        operation: Type.Union([Type.Literal('buy'), Type.Literal('sell')]),
    })),
    funding: Type.Optional(Type.Object({
        at: Type.String(),
        by: Type.String(),
        amount: Type.String(),
        token: Type.String(),
    })),
});
export const PoolHolderChartUpdateSchema = Type.Object({
    pairAddress: Type.String(),
    network: SupportedNetworkSchema,
    holdersCount: Type.Optional(PoolChartPointSchema),
    top10HoldersPercentage: Type.Optional(PoolChartPointSchema),
    insidersHolding: Type.Optional(PoolChartPointSchema),
    snipersHolding: Type.Optional(PoolChartPointSchema),
    bundlersHolding: Type.Optional(PoolChartPointSchema),
    initTxCreator: Type.Optional(InitTxCreatorStatsSchema),
});
//# sourceMappingURL=pool-chart.js.map